import produce, { Draft, enableES5 } from 'immer';
import { CHAR_LIMITS } from 'config/constants';
import { GrammarCheckerControls } from '../models/store';
import { ActionTypes } from '../models/actions';
import {
  HYDRATE_STORE_FROM_SESSION,
  IS_GRAMMAR_CHECK_RUNNING,
  SET_GC_LANGUAGE,
  USER_CHANGED_INPUT_TEXT,
} from '../models/actions/names';

enableES5();

const initState = {
  isGrammarCheckRunning: false,
  showCharLimitMessage: false,
  gcLanguage: 'EN',
};

export const controlReducer = produce(
  (draft: Draft<GrammarCheckerControls>, action: ActionTypes) => {
    switch (action.type) {
      case IS_GRAMMAR_CHECK_RUNNING:
        draft.isGrammarCheckRunning = action.payload.isGrammarCheckRunning;
        break;
      case USER_CHANGED_INPUT_TEXT:
        if (action.payload.wordCount > CHAR_LIMITS.GRAMMAR_CHECKER_WORD_LIMIT) {
          draft.showCharLimitMessage = true;
        } else draft.showCharLimitMessage = false;
        break;
      case SET_GC_LANGUAGE:
        draft.gcLanguage = action.payload;
        break;
      case HYDRATE_STORE_FROM_SESSION:
        try {
          if (action.src === 'CONTROL') {
            return { ...draft, ...action.store };
          }
          // eslint-disable-next-line no-empty
        } catch (e) {}
        break;
    }
  },
  initState
);
